import React from 'react'

import { useAwesomeBarContext } from '../AwesomeBarContext'

interface IContentProps {
  open: boolean
  onSelect?: () => void
  pathname?: string
}

/**
 * This component is responsible for rendering the content of the focus dropdown sections.
 */
const Content = ({ open }: IContentProps) => {
  const { focusDropdownSections, onBlurInput } = useAwesomeBarContext()
  return (
    <React.Fragment>
      {focusDropdownSections.map((ContentComponent, idx) => {
        return (
          <ContentComponent
            key={idx}
            open={open}
            onCloseFocusDropdown={onBlurInput}
          />
        )
      })}
    </React.Fragment>
  )
}

export default Content
